import type { SalesRegion } from '../../../../api/daily-sales';
import { TogglePill } from '../../primitives';
import { regionChoices, SALE_TYPES, type SaleType } from '../daily-sales-filters';

interface DailySalesFiltersProps {
  types: SaleType[];
  regionId: string | null;
  /** Every region; absent until a report arrives. */
  regions?: SalesRegion[];
  onToggleType: (type: SaleType) => void;
  onRegion: (regionId: string | null) => void;
}

/** What to report on: which kinds of sale, and which region's workshop tickets. */
export function DailySalesFilters({
  types,
  regionId,
  regions = [],
  onToggleType,
  onRegion,
}: DailySalesFiltersProps) {
  const chosen = regions.find((r) => r.id === regionId);
  const regionName = chosen?.name ?? 'this region';

  return (
    <section className="nb-card nb-ds-filters" aria-label="What to show">
      <label className="nb-ds-field">
        Region
        <select
          value={regionId ?? ''}
          onChange={(e) => onRegion(e.target.value || null)}
          className="nb-ds-select"
        >
          <option value="">All regions</option>
          {regionId && !chosen && <option value={regionId}>Unknown region</option>}
          {regionChoices(regions).map((r) => (
            <option key={r.id} value={r.id}>
              {r.label}
            </option>
          ))}
        </select>
      </label>
      {regionId ? (
        <p className="nb-ds-meta nb-ds-filter-note">
          Showing workshop tickets in {regionName}. Gift cards, gift passes and retail aren&apos;t
          tied to a region, so they show only with all regions.
        </p>
      ) : (
        <div role="group" aria-label="Sale types" className="nb-ds-types">
          {SALE_TYPES.map((t) => (
            <TogglePill
              key={t.value}
              selected={types.includes(t.value)}
              onClick={() => onToggleType(t.value)}
            >
              {t.label}
            </TogglePill>
          ))}
        </div>
      )}
    </section>
  );
}
